import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './index.module.scss';
import App from './App';
import ImportValidator from './Helpers/ImportValidator';

const container = document.getElementsByTagName('PingNationDashboard')[0];

if (!container) {
  console.error('DOM Element does not exist');
} else {
  const organization = ImportValidator.validateOrganization(container.getAttribute('organization'));
  const tiles = ImportValidator.validateTiles(container.getAttribute('tiles'));
  localStorage.setItem('Organization', organization);

  ReactDOM.render(
    <App
      organization={organization}
      tiles={tiles}
    />,
    container,
  );
}
